import { SxProps } from '@mui/material';

export const OrderProgressShippingCostFrameSx: SxProps = {
	backgroundColor: '#ECF3E7',
	padding: '12px',
	borderRadius: '3px',
};

export const OrderProgressShippingCostIconSx: SxProps = {
	color: '#0F8B3F',
	fontSize: { xs: 'var(--font-size-default)', sm: 'var(--font-size-md)' },
};

export const OrderProgressShippingCostTextSx: SxProps = { fontSize: { xs: 'var(--font-size-small)', sm: 'var(--font-size-default)' } };

export const OrderProgressShippingCostTextEmphasisSx: SxProps = {
	fontWeight: 'bold',
	fontSize: { xs: 'var(--font-size-small)', sm: 'var(--font-size-default)' },
};

export const OrderProgressShippingCostProgressBarFrameSx: SxProps = {
	marginTop: 1,
	backgroundColor: '#A1AFA9',
	borderRadius: '3px',
};

export const OrderProgressShippingCostProgressBarSx = (percentage: number): SxProps => ({
	width: `${percentage}%`,
	maxWidth: '100%',
	backgroundColor: '#0F8B3F',
	height: '5px',
	borderRadius: '3px',
});
